/** Textes « motDePasse » — le français fait foi. */
export const motDePasse = {
  titre: 'Changer mon mot de passe',
  erreur: "Le mot de passe n'a pas pu être changé.",
  fait: "C'est fait",
  actif: 'Votre nouveau mot de passe est actif. Utilisez-le à votre prochaine connexion.',
  fermer: 'Fermer',
  actuel: 'Mot de passe actuel',
  nouveau: 'Nouveau mot de passe',
  minimum: '8 caractères minimum.',
  encore: (n: number) => `Encore ${n} caractère(s).`,
  repetez: 'Répétez le nouveau mot de passe',
  different: 'Les deux ne sont pas identiques.',
  annuler: 'Annuler',
  changer: 'Changer',
};
